import { render, staticRenderFns } from "./coffee-card-base.vue?vue&type=template&id=5f936c1e&scoped=true&"
import script from "./coffee-card-base.vue?vue&type=script&lang=js&"
export * from "./coffee-card-base.vue?vue&type=script&lang=js&"
import style0 from "./coffee-card-base.vue?vue&type=style&index=0&id=5f936c1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f936c1e",
  null
  
)

export default component.exports